import React from "react";

import _ from "lodash";

import { formatNumber, formatNumericCurrency } from "utils";

import { CurrencyCode } from "consts";

import { PayoutDetails, PayoutDetailsPerCategory } from "models";

import { Table } from "components";

interface PayoutsTableProps {
  payouts: PayoutDetailsPerCategory;
  currency: CurrencyCode;
}

type PayoutRow = PayoutDetails & { creditType: keyof PayoutDetailsPerCategory };

const PayoutsTable: React.FC<PayoutsTableProps> = ({ payouts, currency }) => (
  <Table<PayoutRow>
    data={(_.keys(payouts) as PayoutRow["creditType"][]).map((creditType) => ({ creditType, ...payouts[creditType] }))}
    rowKey="creditType"
    pagination={false}
    columns={[
      { title: "Credit type", dataIndex: "creditType", render: (creditType: string) => _.upperFirst(creditType) },
      {
        title: "Price per kg CO₂",
        dataIndex: "pointPrice",
        render: (pointPrice: number) => formatNumericCurrency(pointPrice, { currency, decimals: 3 }),
      },
      {
        title: "Permanence buffer",
        dataIndex: "permanenceBufferPercentage",
        render: (buffer?: number) => (buffer === undefined ? "None" : `${formatNumber({ number: buffer * 100, decimalPlaces: 0 })} % held back`),
      },
    ]}
  />
);

export default PayoutsTable;
